<template>
  <SectionCard id="merge" :class="isPcFlag ? 'system-integration-pc' : 'system-integration-h5'" :isPcFlag="isPcFlag" title="系统融合">
    <div class="integration-content" v-if="isPcFlag">
      <ul class="tab_title">
        <li v-for="(v, i) in dataList" :class="m == i ? 'active' : ''" @click="m = i" :key="i.title">{{ v.title }}</li>
      </ul>
      <!-- 内容 -->
      <div class="tab_content">
        <div class="content-item" v-for="(v, i) in dataList" v-show="m == i" :key="i">
          <div class="content-one" v-if="v.title === '多系统无缝对接'">
            <div class="left">
              <img class="img" src="@/assets/images/landing-signet/xtrh_one_one.png" alt="" />
              <div class="text">
                通过接口调用（API+SDK）的形式，统一平台处理，完成从用印的全部申请、审批、盖印+电签、记录查看的完整流程；直接将思格特与现有系统进行数据和流程的打通，实现数据集成展现，同时保留已有的操作习惯；
              </div>
            </div>
            <div class="right">
              <div class="right-item" v-for="(item, index) in v.content" :key="index">
                <img class="icon" :src="item.icon" alt="" />
                <div class="item">
                  <div class="title">{{ item.tit }}</div>
                  <div class="desc">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>
          <img class="img" :src="v.img" alt="" />
        </div>
      </div>
    </div>
    <div class="h5-integration-content" v-else>
      <div class="content-item" v-for="(item, index) in dataList" :key="index" @click="activeItem(index)">
        <div class="title" :class="activeIndex[index] ? 'active-item' : ''">
          <p class="text">{{ item.title }}</p>
          <img class="icon" src="@/assets/images/landing-signet/h5_bottom.png" v-show="!activeIndex[index]" alt="" />
          <img class="icon" src="@/assets/images/landing-signet/h5_top.png" v-show="activeIndex[index]" alt="" />
        </div>
        <div class="content-box" v-show="activeIndex[index]">
          <div class="content-one" v-if="item.title === '多系统无缝对接'">
            <img class="img" src="@/assets/images/landing-signet/xtrh_one_one.png" alt="" />
            <div class="text">
              通过接口调用（API+SDK）的形式，统一平台处理，完成从用印的全部申请、审批、盖印+电签、记录查看的完整流程；直接将思格特与现有系统进行数据和流程的打通，实现数据集成展现，同时保留已有的操作习惯；
            </div>
            <div class="duijie-list">
              <div class="duijie-item-box" v-for="(i, index) in item.content" :key="index">
                <img class="duijie-icon" :src="i.icon" alt="" />
                <div class="duijie-item">
                  <div class="duijie-title">{{ i.tit }}</div>
                  <div class="duijie-desc">{{ i.desc }}</div>
                </div>
              </div>
            </div>
          </div>
          <img class="img" :src="item.imgH5" alt="" />
        </div>
      </div>
    </div>
  </SectionCard>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
  components: {
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
  },
  data() {
    return {
      m: 0,
      activeIndex: [true],
    }
  },
  methods: {
    activeItem(index) {
      this.activeIndex[index] = !this.activeIndex[index]
      this.activeIndex = [...this.activeIndex]
    },
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
// pc样式
.system-integration-pc {
  .integration-content {
    .columnDisplay(center,center);

    .tab_title {
      width: 100%;
      height: 58px;
      background: #f3f3f3;
      border-radius: 8px 8px 0px 0px;
      .basisDisplay(space-around,center);
      li {
        width: 330px;
        height: 100%;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        text-align: center;
        line-height: 58px;
      }
      li:hover {
        cursor: pointer;
      }
      li.active {
        background: linear-gradient(270deg, #e63740 0%, #ff8866 59%, #fff3c7 100%);
        box-shadow: 0px 4px 7px 0px #dfe6f3;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        border: 2px solid #ffffff;
      }
    }
    .content-item {
      box-shadow: 0px 4px 13px 0px rgba(204, 214, 227, 0.8);
      .content-one {
        padding: 45px 85px 74px 80px;
        .basisDisplay(space-between,center);
        .left {
          .columnDisplay(center,center);
          margin-right: 65px;
          .img {
            width: 316px;
            height: 270px;
            margin-bottom: 23px;
          }
          .text {
            width: 577px;
            height: 140px;
            background: #404040;
            padding: 18px 38px;
            font-size: 19px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 26px;
          }
        }
        .right {
          .right-item {
            .basisDisplay(flex-start,center);
            margin-bottom: 40px;
            .icon {
              margin-right: 20px;
              width: 70px;
              height: 70px;
            }
            .item {
              .columnDisplay(center,flex-start);
              margin-top: 5px;
              .title {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #404040;
                margin-bottom: 8px;
              }
              .desc {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #262626;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }
}

// h5样式
.system-integration-h5 {
  .h5-integration-content {
    .content-item {
      width: 100%;
      height: auto;
      .title {
        padding: 0 0.32rem;
        .basisDisplay(space-between,center);
        width: 100%;
        height: 1.2267rem;
        background: #f1f2f5;
        border-radius: 0.1067rem;
        border: 0.0267rem solid #e4e4e4;
        color: #272727;
        font-size: 0.3733rem;
        margin-bottom: 0.3733rem;
        .text {
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
        }
        .icon {
          width: 0.6667rem;
          height: 0.6667rem;
        }
      }
      .active-item {
        background: linear-gradient(270deg, #e63740 0%, #ff8866 66%, #ffa17d 100%);
        border-radius: 0.1067rem 0.1067rem 0 0;
        border: 0.0533rem solid #ffffff;
        font-size: 0.4267rem;
        color: #ffffff;
        margin-bottom: 0;
      }
      .content-box {
        padding: 0.48rem 0.32rem;
        background: #f8f9fb;
        box-shadow: 0 0.0533rem 0.2133rem 0 #d7e1ed;
        border-radius: 0 0 0.1067rem 0.1067rem;
        margin-bottom: 0.3733rem;
        .content-one {
          .img {
            width: 6.2667rem;
            margin: 0 auto;
          }
          .text {
            padding: 0.4533rem 0.24rem;
            background: #404040;
            font-size: .32rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            margin: 0.3733rem 0 0.8rem 0;
            line-height: 0.4533rem;
          }
          .duijie-list {
            .duijie-item-box {
              .basisDisplay(space-between,flex-start);
              .duijie-icon {
                width: 1.2533rem;
                height: 1.2533rem;
              }
              .duijie-item {
                .columnDisplay(center,flex-start);
                margin-bottom: 0.6133rem;
                margin-left: 0.2133rem;
                .duijie-title {
                  font-size: 0.3733rem;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #404040;
                }
                .duijie-desc {
                  font-size: 0.2667rem;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #262626;
                  line-height: 0.3733rem;
                  margin-top: 0.1333rem;
                }
              }
            }
          }
        }
        .img {
          margin-bottom: 0.2667rem;
        }
      }
    }
  }
}
</style>